import React from "react"
import { Link } from "gatsby"
import LinkedinIcon from "../../assets/linkedin.svg"
import XIcon from "../../assets/X.svg"
import ThreadsIcon from "../../assets/threads.svg"
import DiscordIcon from "../../assets/discord.svg"
import "./Footer.scss"

const triggerPlausibleEvent = event => {
  if (window && window.plausible) {
    window.plausible(event)
  }
}

const Footer = () => (
  <footer className="multiplayer-footer">
    <div className="multiplayer-pages">
      <a
        onClick={() => triggerPlausibleEvent("ContactFromFooter")}
        href="mailto:hello@multiplayer.app"
      >
        hello@multiplayer.app
      </a>
    </div>
    <div className="multiplayer-footer-nav">
      <a
        onClick={() => triggerPlausibleEvent("BlogFromMenu")}
        href="https://www.multiplayer.app/blog"
        rel="noreferrer"
      >
        Blog
      </a>
      <a
        onClick={() => triggerPlausibleEvent("DiscordFromMenu")}
        href="https://discord.gg/q9K3mDzfrx"
        target="_blank"
        rel="noreferrer"
      >
        Discord
      </a>
      <Link
        onClick={() => {
          triggerPlausibleEvent("ContactFromMenu")
        }}
        to="/contact"
      >
        Contact
      </Link>
      <Link
        onClick={() => {
          triggerPlausibleEvent("PrivacyFromMenu")
        }}
        to="/privacy"
      >
        Privacy Policy
      </Link>
      <Link
        onClick={() => {
          triggerPlausibleEvent("TOSFromMenu")
        }}
        to="/terms-of-service"
      >
        Terms of Service
      </Link>
    </div>
    <div className="multiplayer-social">
      <a
        onClick={() => triggerPlausibleEvent("SocialThreads")}
        href="https://www.threads.net/@trymultiplayer"
        target="_blank"
        rel="noreferrer"
      >
        <ThreadsIcon />
      </a>
      <a
        onClick={() => triggerPlausibleEvent("SocialTwitter")}
        href="https://twitter.com/trymultiplayer"
        target="_blank"
        rel="noreferrer"
      >
        <XIcon />
      </a>
      <a
        onClick={() => triggerPlausibleEvent("SocialLinkedIn")}
        href="https://www.linkedin.com/company/multiplayer-app"
        target="_blank"
        rel="noreferrer"
      >
        <LinkedinIcon />
      </a>
      <a
        onClick={() => triggerPlausibleEvent("SocialDiscord")}
        href="https://discord.gg/q9K3mDzfrx"
        target="_blank"
        rel="noreferrer"
      >
        <DiscordIcon />
      </a>
    </div>
    {new Date().getFullYear()} Multiplayer © All rights reserved.
  </footer>
)

export default Footer
